
  import { mapActions, mapGetters } from 'vuex'

  import { ListingPriceFilter } from '@loavies/c2c-models'
  import AppInput from '@loavies/component-library/dist/app-input'

  export default {
    components: {
      AppInput,
    },
    props: {
      priceFilter: {
        type: ListingPriceFilter,
        required: true,
      },
    },
    data() {
      return {
        [this.priceFilter.type]: null,
      }
    },
    computed: {
      ...mapGetters({
        getActivePriceFilterAmount: 'listings/getActivePriceFilterAmount',
      }),
      activePriceFilterAmount() {
        return this.getActivePriceFilterAmount(this.priceFilter)
      },
      label() {
        return this.$t(`filter_${this.priceFilter.key}`)
      },
      inputBindings() {
        return {
          id: this.priceFilter.key,
          value: this[this.priceFilter.type],
          placeholder: this.$currencyService.formatCentsToLocalePrice(this.priceFilter.amount),
        }
      },
    },
    watch: {
      // To reset input after all filters are reset
      activePriceFilterAmount() {
        if (this.activePriceFilterAmount !== this[this.priceFilter.type]) {
          this[this.priceFilter.type] = this.activePriceFilterAmount / 100
        }
      },
    },
    mounted() {
      this[this.priceFilter.type] = this.activePriceFilterAmount / 100
    },
    methods: {
      ...mapActions({
        setActivePriceFilter: 'listings/setActivePriceFilter',
        removeActivePriceFilter: 'listings/removeActivePriceFilter',
      }),
      handleInput(value) {
        this[this.priceFilter.type] = value.trim().length === 0 ? null : Number(value)
      },
      handleBlur() {
        if (this[this.priceFilter.type]) {
          return this.setActivePriceFilter(this.priceFilter.assign({
            amount: this[this.priceFilter.type] * 100,
          }))
        }

        this.removeActivePriceFilter(this.priceFilter)
      },
    },
  }
